import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ["Prepari le lezioni all'ultimo minuto e spesso improvvisi troppo.", 'Alcuni studenti perdono motivazione rapidamente e fanno pochi progressi.', 'Ripeti sempre gli stessi esercizi e le lezioni rischiano di diventare monotone.', 'Sai insegnare musica, ma senti di non avere ancora un metodo davvero strutturato e professionale.'];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-226">
      <div className="max-w-4xl mx-auto" data-id="element-227">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-228">
          Ti riconosci in una di queste situazioni?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-229">
          {painPoints.map((point, index) => <div key={index} className="bg-red-50 border border-red-100 rounded-xl p-6 flex items-start shadow-sm hover:shadow-md transition-shadow" data-id="element-230">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1 mr-4" data-id="element-231" />
              <p className="text-lg text-gray-800 font-medium leading-relaxed" data-id="element-232">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}